import React, { useState, useEffect, useRef } from "react";
import { getTable } from "../../../config/seatable";
import "../Food/food.css";
import Header from "../Header";
import Footer from "../Footer/Footer";
import veg from "../../../assets/food/veg.png";
import nonveg from "../../../assets/food/nonveg.png";
import Select from "react-select";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

function Food() {
  const pdfContentRef = useRef(null);

  const [categories, setCategories] = useState([]);
  const [fooditems, setFoodItems] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [foodTypes, setFoodTypes] = useState([]);
  const [selectedType, setSelectedType] = useState([]);
  const [Loader, setLoader] = useState(false);
  const [showPdfContent, setShowPdfContent] = useState(false);
  const [showDesc, setShowDesc] = useState({});
  const [dataLoading, setDataLoading] = useState(false);

  useEffect(() => {
    const fetchFood = async () => {
      try {

        setDataLoading(true)
        const categoriesResponse = await getTable("FoodCategory");
        const fooditemsResponse = await getTable("FoodItem");
        const foodTypesResponse = await getTable("DietaryPreference");

        setCategories(categoriesResponse.rows || []);
        setFoodItems(fooditemsResponse.rows || []);
        setFoodTypes(foodTypesResponse.rows || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      finally {
      setDataLoading(false); // stop loader
    }
    };

    fetchFood();
  }, []);

  const categoryOptions = categories.map((cat) => ({
    value: cat["0000"],
    label: cat["0000"],
  }));

  const foodTypesOptions = foodTypes.map((e) => ({
    value: e["0000"],
    label: e["0000"],
  }));

  // Filter 1: By categories
  let itemsAfterCategoryFilter =
    selectedCategories.length === 0
      ? fooditems
      : fooditems.filter((item) =>
          selectedCategories.some(
            (cat) => cat.value === item?.h87O?.[0]?.display_value
          )
        );

  // Filter 2: By food type (veg/nonveg)
  let finalFilteredItems =
    selectedType.length === 0
      ? itemsAfterCategoryFilter
      : itemsAfterCategoryFilter.filter((item) =>
          selectedType.some(
            (type) => type.value === item?.RDRX?.[0]?.display_value
          )
        );

  // Group result by category
  const groupedItems = categories.reduce((acc, cat) => {
    const catName = cat["0000"];
    const catItems = finalFilteredItems.filter(
      (item) => item?.h87O?.[0]?.display_value === catName
    );

    if (catItems.length > 0) {
      acc.push({ name: catName, items: catItems });
    }
    return acc;
  }, []);

  // ===========================
  // PDF DOWNLOAD METHOD
  // ===========================
  const downloadPDF = () => {
    const pdfContent = pdfContentRef.current;
    if (!pdfContent) return;

    setLoader(true);
    setShowPdfContent(true); // show hidden block only during capture

    setTimeout(() => {
      html2canvas(pdfContent, { scale: 2 }).then((canvas) => {
        const imgData = canvas.toDataURL("image/jpeg", 0.9);
        const pdf = new jsPDF("p", "mm", "a4");

        const imgWidth = 210;
        const pageHeight = 297;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        let heightLeft = imgHeight;
        let position = 0;

        pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft > 0) {
          pdf.addPage();
          position = heightLeft - imgHeight;
          pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }

        pdf.save("food-menu.pdf");

        // hide the content immediately after saving
        setShowPdfContent(false);
        setLoader(false);
      });
    }, 300);
  };

  return (
    <>
      <Header />

        {
          dataLoading && (
           <div className="loader-overlay">
    <div className="loader"></div>
    <p style={{ color: "#fff", marginTop: "10px" }}>Loading menu...</p>
  </div>
          )
        }
     {
      !dataLoading && (
         <div className="py-4 foodmenu px-md-5 px-3 pt-5">
        {/* FILTER BAR */}
        <div
          className="mx-auto d-flex flex-wrap justify-content-center gap-3 align-items-center mb-4 rounded"
          style={{
            width: "fit-content",
            marginTop: "100px",
            background: "#5c5c5c",
            padding: "10px",
          }}
        >
          <Select
            isMulti
            options={categoryOptions}
            value={selectedCategories}
            onChange={setSelectedCategories}
            placeholder="Select Categories"
          />

          <Select
            isMulti
            options={foodTypesOptions}
            value={selectedType}
            onChange={setSelectedType}
            placeholder="Select Type"
          />

          <button
            onClick={downloadPDF}
            style={{
              padding: "10px 20px",
              backgroundColor: "#e6be80",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Download PDF
          </button>

          {Loader && (
            <div className="loader-overlay">
              <div className="loader"></div>
              <p style={{ color: "#fff", marginTop: "10px" }}>
                Generating PDF...
              </p>
            </div>
          )}
        </div>

        {/* NORMAL WEBSITE VIEW (CARDS) */}
        <div className="row container-fluid px-md-5 px-0 mx-auto">
          {groupedItems.map((group, id) => (
            <div key={id} className="mb-5 col-md-6 col-lg-4">
              <div className="fooditemcard h-100 p-md-5 p-4">
                <h5 className="mb-3 text-white pb-4">{group.name}</h5>

                <div className="g-3">
                  {group.items.map((food, index) => {
                    const itemtype = food?.RDRX?.[0]?.display_value;
                    const uniqueKey = `${group.name}-${index}`;

                    return (
                      <div
                        key={index}
                        className="d-flex gap-3 align-content-center"
                      >
                        <p className="py-3">
                          <img
                            src={itemtype === "Veg" ? veg : nonveg}
                            width={15}
                            alt=""
                          />
                        </p>

                        <div className="border-bottom border-white border-opacity-25 w-100 pb-3">
                          <p
                            onClick={() =>
                              setShowDesc((prev) => ({
                                ...prev,
                                [uniqueKey]: !prev[uniqueKey],
                              }))
                            }
                            className="card-title pt-3 pb-2"
                            style={{ cursor: "pointer" }}
                          >
                            {food["0000"]}
                          </p>

                          {showDesc[uniqueKey] && (
                            <small className="text-secondary">
                              {food["3A0P"] || "No description available"}
                            </small>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* ===========================
            HIDDEN PDF CONTENT (MASONRY)
        =========================== */}
        <div
          ref={pdfContentRef}
          style={{ display: showPdfContent ? "block" : "none" }}
          className="container-fluid px-md-5 px-3 py-5 mx-auto bg-white masonry"
        >
          {groupedItems.map((group, id) => (
            <div key={id} className="masonry-item" style={{ paddingRight: 20 }}>
              <ul style={{ listStyle: "none", paddingLeft: 0, margin: 0 }}>
                <h4 className="text-black mb-2 text-bold">{group.name}</h4>

                {group.items.map((food, index) => (
                  <li
                    key={index}
                    className="d-flex align-items-center mb-1"
                    style={{ paddingBottom: 4 }}
                  >
                    <img
                      src={
                        food?.RDRX?.[0]?.display_value === "Veg"
                          ? veg
                          : nonveg
                      }
                      width={12}
                      alt=""
                      style={{ marginRight: "6px" }}
                    />
                    <span>{food["0000"]}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      )
     }
      <Footer />

      {/* Loader CSS */}
      <style>{`
        .loader-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100vh !important;
          background: rgba(0, 0, 0) !important;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          z-index: 9999;
        }

        .loader {
          border: 5px solid rgba(255, 255, 255, 0.3);
          border-top: 5px solid #e6be80;
          border-radius: 50%;
          width: 50px;
          height: 50px;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </>
  );
}

export default Food;
